import React from 'react';
import {Grid, Typography} from "@mui/material";
import "./style.css";
import {formatCurrencyValue} from "../../../util/PaymentUtils";
import {styled} from "@mui/material/styles";

const MarginBottom1 = styled(Typography)(() => ({
  marginBottom: '1em'
}));

interface OverageRatePriceProps {
  overageRateInCents?: number | null;
}

const OverageRatePrice = (props: OverageRatePriceProps) => {
  const {overageRateInCents} = props;

  let formattedPrice: string | number = "$0.00";
  if (overageRateInCents !== null && overageRateInCents !== undefined && overageRateInCents >= 0) {
    formattedPrice = formatCurrencyValue(overageRateInCents, true);
  }

  return (
    <Grid item container>
      <MarginBottom1 variant={'h6'} color={'textPrimary'}>Overage Rate</MarginBottom1>
      <Grid item container justifyContent={'space-between'}>
        <Typography component={'h6'} className={'ss-location-profile-section-subtitle'}>Price/Day</Typography>
        <Typography component={'h6'} className={'ss-location-profile-section-subtitle'}>
          {formattedPrice}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default OverageRatePrice;
